
import { Component, Prop, Vue } from "vue-property-decorator";

const ICONS = {
  bell: "bell",
};

const CLASS = "notification-bell";

@Component
export default class AppMainNotification extends Vue {
  @Prop({ type: Boolean, default: true }) readonly border: boolean;
  @Prop({ type: Boolean, default: false }) readonly selected: boolean;
  @Prop({ type: Array, default: [] }) readonly notifications;

  icons = ICONS;

  get classes() {
    const { border, selected } = this;

    return {
      [`${CLASS}_border`]: border,
      [`${CLASS}_selected`]: selected,
    };
  }

  toggle() {
    this.$emit("toggle");
  }

  get newNotifications() {
    return this.notifications.filter((item) => item.status === "new");
  }

  get showIndicator() {
    return this.newNotifications.length;
  }
}
